import axios from '../config/axios';

const consultarCitasPaciente = async (documento, estado, cantidadMeses) => await axios.post('/agendamiento/api/v1/horariosPorPaciente', { documento, estado, cantidadMeses });
const consultarCitasResponsable = async (responsable, estado, dia) => await axios.post('/agendamiento/api/v1/horariosPorResponsable', { responsable, estado, dia });
const consultarDisponibilidad = async (key, semana, sede) => await axios.post('/agendamiento/api/v1/fecha_disponible', { key, semana, sede });
const agendarCita = async (data) => await axios.post('/agendas/agendar_cita_desde_front', data);
const obtenerProcedimientos = async () => await axios.get('/agendamiento/api/v1/ordenes/procedimientos/nombre').then(res => res.data);
const obtenerHorariosPorDia = async (estado, fechaCita, cups) => await axios.get(`/agendamiento/api/v1/horariosPorDia/${estado}/${fechaCita}/${cups}`).then(res => res.data);


export {
  consultarCitasPaciente,
  consultarCitasResponsable,
  consultarDisponibilidad,
  agendarCita,
  obtenerProcedimientos,
  obtenerHorariosPorDia
};

export async function cancelarCita(documento, ordenId, canceladoPor) {
  return await axios.post("/agendas/cancelar_cita_desde_front", {
    documento,
    ordenId,
    canceladoPor
  });
}
/**
 * Function to send notifications of the arrival of the patient
 * @param {String} creado_por
 * @param {String} nombrePaciente
 * @param {String} evento
 * @param {Numbre} documento
 * @param {String} responsable
 * @param {String} ordenId
 * @param {Numbre} fechaHoraCita
 * @returns
 */
export async function sendNotification(
  creado_por,
  nombrePaciente,
  evento,
  documento,
  responsable,
  ordenId,
  fechaHoraCita
) {
  return await axios.post(
    "/gestion_notificaciones/notificaciones/api/v1/notification_hc",
    {
      creado_por,
      nombrePaciente,
      evento,
      documento,
      responsable,
      ordenId,
      fechaHoraCita
    }
  );
}
/**
 * function to change the status of the order from assigned to invoice
 * @param {Numbre} documento
 * @param {String} creado_por
 * @param {String} procedimiento
 * @param {String} estado
 * @param {Array} newData
 * @returns
 */
export async function switchToInvoice(
  documento,
  creado_por,
  procedimiento,
  estado,
  newData
) {
  return await axios.post("/agendamiento/api/v2/ordenes/actualizar", {
    documento,
    creado_por,
    procedimiento,
    estado,
    newData
  });
}


// WEBPACK FOOTER //
// ./src/apiService/request/Agendamiento.js